module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pessoa/pessoa.component.css
// module id = ./src/app/pessoa/pessoa.component.css
// module chunks = main